import { render, staticRenderFns } from "./SiteHistoryRecord.vue?vue&type=template&id=387cfb69&scoped=true"
import script from "./SiteHistoryRecord.vue?vue&type=script&lang=js"
export * from "./SiteHistoryRecord.vue?vue&type=script&lang=js"
import style0 from "./SiteHistoryRecord.vue?vue&type=style&index=0&id=387cfb69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cfb69",
  null
  
)

export default component.exports